import { JsonRpcProvider } from 'ethers';

class Provider {
    private state: Record<string, JsonRpcProvider> = {};

    get(url: string) {
        if (this.state[url]) {
            return this.state[url];
        }

        const provider = new JsonRpcProvider(url, {
            name: 'world',
            chainId: 480,
        });
       
        return provider;
    }
}

export const sharedProvider = new Provider();
